<template>
  <div class="page">
    <!-- 头部 -->
    <div class="page-header">
      <el-divider content-position="left">服务单号（{{insBillId || '————'}}）</el-divider>
    </div>
    <!-- 基本信息 -->
    <BaseInfo :infoOptions="detailBaseInfoOption" :infoData="formData.bill_data" />
    
    <!-- 车辆信息 -->
    <el-tabs class="card-info shadow" type="border-card">
      <el-tab-pane label="车辆信息">
        <BaseInfo labelWidth="120" :infoOptions="detailCarInfoOption" :infoData="formData.car_data" />
      </el-tab-pane>
      <el-tab-pane label="关系人信息">
        <FoldedPanel>
          <template #title>被服务人</template>
          <BaseInfo :infoOptions="detailPersonInfoOption" :infoData="formData.person_data[0]" />
        </FoldedPanel>
        <FoldedPanel>
          <template #title>参统人</template>
          <BaseInfo :infoOptions="detailPersonInfoOption" :infoData="formData.person_data[1]" />
        </FoldedPanel>
        <FoldedPanel>
          <template #title>车主</template>
          <BaseInfo :infoOptions="detailPersonInfoOption" :infoData="formData.person_data[2]" />
        </FoldedPanel>
      </el-tab-pane>
      <el-tab-pane label="服务明细">
        <FoldedPanel>
          <template #title>
            <span class="panel-header-text"
              ><i class="icon el-icon-menu">主服务类型</i></span
            >
          </template>
          <el-table :data="majorData" style="width: 100%">
            <el-table-column prop="project" min-width="200" label="项目">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 3">
                  <span v-if="!scope.row.isCheck"
                    >{{ scope.row.project }}{{ scope.row.absolute }}元/座
                    <span
                      >共{{ formData.car_data.passengerCount }}座</span
                    ></span
                  >

                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ scope.row.project }}
                    <el-select v-model="scope.row.absolute" filterable placeholder="万元" @change="detailTtemChange">
                      <el-option
                        v-for="item in $emun.seatOption"
                        :key="item.label"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                    <span>共{{ formData.car_data.passengerCount }}座</span>
                  </div>
                </div>
                <div v-else>
                  <span v-if="!scope.row.isCheck"
                    >{{ scope.row.project }}{{ scope.row.absolute }}</span
                  >
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ scope.row.project }}
                    <el-input
                      v-if="scope.row.type === 0"
                      v-model="scope.row.absolute"
                      placeholder="元"
                      @change="detailTtemChange"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="服务额(元)">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 3">
                  {{
                    (
                      scope.row.absolute * formData.car_data.passengerCount
                    ).toFixed(2)
                  }}元
                </div>
                <div v-else>
                  <span v-if="!scope.row.isCheck"
                    >{{ (scope.row.amount * 1).toFixed(2) }}元</span
                  >
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    <el-input
                      v-model="scope.row.amount"
                      placeholder="元"
                      @change="detailTtemChange"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="standard" label="标准服务费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.standard * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.standard"
                    placeholder="元"
                    @change="detailTtemChange"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="practical" label="应交服务费(元)">
              <template slot-scope="scope">
                {{ (formData.bill_data.cusRebate * scope.row.standard).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <FoldedPanel>
          <template #title>
            <span class="panel-header-text"
              ><i class="icon el-icon-menu">附加服务类型</i></span
            >
          </template>
          <el-table :data="additionData" style="width: 100%">
            <el-table-column prop="project" min-width="200" label="项目">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ scope.row.project }}{{ scope.row.absolute }}</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  {{ scope.row.project }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="服务额(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ (scope.row.amount * 1).toFixed(2) }}元</span>
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.amount"
                    placeholder="元"
                    @change="detailTtemChange"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="standard" label="标准服务费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.standard * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.standard"
                    placeholder="元"
                    @change="detailTtemChange"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="practical" label="应交服务费(元)">
              <template slot-scope="scope">
                {{ (formData.bill_data.cusRebate * scope.row.standard).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <div class="panel-detail-footer">
          <div class="panel-detail-footer-left">
            <div class="label">整单折扣：{{ formData.bill_data.cusRebate }}</div>
          </div>
          <div class="panel-detail-footer-right">
            <span class="mr15">标准服务费合计：{{ standardTotal }}元</span>
            <span>应交服务费合计：{{ practicalTotal }}元</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="附件">
        <FoldedPanel
          v-for="item in encList"
          :key="item.title"
        >
          <template #title>{{item.title}}</template>
          <div class="img-box">
            <el-image
              v-for="img in item.fileList"
              :key="img.url"
              class="img-box-item shadow"
              style="width: 100px; height: 100px"
              :src="img.url"
              :preview-src-list="[img.url]">
            </el-image>
          </div>
        </FoldedPanel>
      </el-tab-pane>
      <el-tab-pane label="特别约定">
        {{ formData.bill_data.specialRemark }}
      </el-tab-pane>
      <el-tab-pane label="日志信息">
        <el-steps direction="vertical">
          <el-step>
            <template #title>2021-12-13 16:00:00</template>
            <template #description>
              <span>管理元：</span>
              <span>设置用户折扣，修改后折扣 0.9,修改后用户应交 7530.5</span>
            </template>
          </el-step>
          <el-step title="步骤 2"></el-step>
          <el-step title="步骤 3" description="这是一段很长很长很长的描述性文字"></el-step>
        </el-steps>
      </el-tab-pane>
      <el-tab-pane label="备注">
        {{ formData.bill_data.remark }}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { detailBaseInfoOption, detailCarInfoOption, detailPersonInfoOption } from './formOptions'

export default {
  name: "Recording",
  comments: {},
  data() {
    return {
      standardTotal: 0,
      practicalTotal: 0,
      formData: {
        //主要信息
        bill_data: {},
        //车辆信息
        car_data: {
          passengerCount: 0,
        },
        //人员关系信息
        person_data: [
          {
            personType: 0,
            isgroup: 0,
          },
          {
            personType: 1,
            isgroup: 0,
          },
          {
            personType: 2,
            isgroup: 0,
          },
        ],
        //附件信息
        enc_data: [],
        //服务详细信息
        detail_data: {},
      },
      // 主服务类型
      majorData: [
        {
          type: 0,
          project: "机动车损失服务 绝对免赔额",
          absolute: 0, // 绝对免赔
          amount: 0, // 服务额
          standard: 0, // 标准服务
          discount: 1, // 折扣
          practical: 0, // 应付服务
        },
        {
          type: 1,
          project: "第三者责任服务",
          absolute: "", // 绝对免赔
          amount: 0, // 服务额
          standard: 0, // 标准服务
          discount: 1, // 折扣
          practical: 0, // 应付服务
        },
        {
          type: 2,
          project: "车上人员责任服务(司机)",
          absolute: "", // 绝对免赔
          amount: 0, // 服务额
          standard: 0, // 标准服务
          discount: 1, // 折扣
          practical: 0, // 应付服务
        },
        {
          type: 3,
          project: "车上人员责任服务(乘客)",
          absolute: "", // 绝对免赔
          amount: 0, // 服务额
          standard: 0, // 标准服务
          discount: 1, // 折扣
          practical: 0, // 应付服务
        },
      ],
      // 附加服务列表
      additionData: [
        {
          type: 0,
          project: "车上货物责任服务",
          absolute: 0, // 绝对免赔
          amount: 0, // 服务额
          standard: 0, // 标准服务
          discount: 0, // 折扣
          practical: 0, // 应付服务
        },
      ],
      // 附件回显相关
      identityPhoto: [],
      drivingPhoto: [],
      businessPhoto: [],
      validatePhoto: [],
      standardPhoto: [],
      otherPhoto: [],
    };
  },
  computed: {
    detailBaseInfoOption,
    detailCarInfoOption,
    detailPersonInfoOption,
    collapseList() {
      return [
        {
          title: "被服务人",
          key: 0,
        },
        {
          title: "参统人",
          key: 1,
        },
        {
          title: "车主",
          key: 2,
        },
      ];
    },
    encList() {
      //附件
      return [
        {
          title: "身份证",
          imageType: 1,
          max: 5,
          fileList: this.identityPhoto,
          prop: 'identityPhoto'
        },
        {
          title: "行驶证",
          imageType: 2,
          max: 5,
          fileList: this.drivingPhoto,
          prop: 'drivingPhoto'
        },
        {
          title: "营业执照",
          imageType: 3,
          max: 5,
          fileList: this.businessPhoto,
          prop: 'businessPhoto'
        },
        {
          title: "验车照片",
          imageType: 4,
          max: 5,
          fileList: this.validatePhoto,
          prop: 'validatePhoto'
        },
        {
          title: "标准费用参考图",
          imageType: 5,
          max: 5,
          fileList: this.standardPhoto,
          prop: 'standardPhoto'
        },
        {
          title: "其他",
          imageType: 6,
          max: 8,
          fileList: this.otherPhoto,
          prop: 'otherPhoto'
        },
      ];
    },
    
  },
  created() {
    this.handleSearh()
  },
  methods: {
    // 回显详情
    async handleSearh() {
      const { insBillId } = this.$route.query
      this.insBillId = insBillId
      const res = await this.$api.post("/admin/insbill/getDetailByBid", {
        insBillId,
      });
      console.log(res.data.base)
      // 回显基本信息
      const billData = {
        ...res.data.base,
        days: this.$tools.getDaysBetween(res.data.base.beginTime, res.data.base.endTime)
      }
      // 回显车辆信息
      const carData= {
        ...res.data.car
      }
      // 回显关系人信息
      const personData = [
        ...res.data.person.map(item => ({...item, isgroup: item.isgroup ? '团队': '个人'}))
      ]
      // 回显附件信息
      res.data.enc.forEach(ele => {
        if(ele.imageType === 1) {
          this.identityPhoto.push(ele)
        }
        if(ele.imageType === 2) {
          this.drivingPhoto.push(ele)
        }
        if(ele.imageType === 3) {
          this.businessPhoto.push(ele)
        }
        if(ele.imageType === 4) {
          this.validatePhoto.push(ele)
        }
        if(ele.imageType === 5) {
          this.standardPhoto.push(ele)
        }
        if(ele.imageType === 6) {
          this.otherPhoto.push(ele)
        }
      })
      this.majorData = this.majorData.map(element => {
        for( let k in res.data.item) {
          if(element.type === 0 && k === 'z_cs_jdmp' && res.data.item[k]) {
            element.absolute = res.data.item[k]
          }
          if(element.type === 0 && k === 'z_cs_tcje' && res.data.item[k]) {
            element.amount = res.data.item[k]
          }
          if(element.type === 0 && k === 'z_cs_bjje' && res.data.item[k]) {
            element.standard = res.data.item[k]
          }

          if(element.type === 1 && k === 'z_sz_tcje' && res.data.item[k]) {
            element.amount = res.data.item[k]
          }
          if(element.type === 1 && k === 'z_sz_bjje' && res.data.item[k]) {
            element.standard = res.data.item[k]
          }

          if(element.type === 2 && k === 'z_sj_tcje' && res.data.item[k]) {
            element.amount = res.data.item[k]
          }
          if(element.type === 2 && k === 'z_sj_bjje' && res.data.item[k]) {
            element.standard = res.data.item[k]
          }

          if(element.type === 3 && k === 'z_ck_zwje' && res.data.item[k]) {
            element.absolute = res.data.item[k]
          }
          if(element.type === 3 && k === 'z_ck_bjje' && res.data.item[k]) {
            element.standard = res.data.item[k]
          }
          if(element.type === 3 && k === 'z_ck_tcje' && res.data.item[k]) {
            element.amount = res.data.item[k]
          }
          res.data.item[k]
        }
        return element
      })
      this.additionData = [
        {
          type: 0,
          isCheck: false,
          project: "车上货物责任服务",
          absolute: 0, // 绝对免赔
          amount: res.data.item.f_zdxl_tcje, // 服务额
          standard: res.data.item.f_zdxl_bjje, // 标准服务
          discount: 0, // 折扣
          practical: 0, // 应付服务
        }
      ]
      this.standardTotal = res.data.base.contractFee || 0;
      this.practicalTotal = res.data.base.cusFee || 0;
    
      console.log(this.majorData)
      this.formData = {
        bill_data: {
          ...billData
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
          ...carData,
          accidentCount: res.data.base.accidentCount,
          insYears: res.data.base.insYears
        },
        //人员关系信息
        person_data: [
          ...personData
        ],
        //附件信息
        enc_data: [],
        //服务详细信息
        detail_data: {},
        // 特别约定
        template_data: {
          templateContent: ''
        }
        // car_data: res.data.car,
        // bill_data: res.data.base,
      }
      // this.formData.bill_data
      console.log(res)
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;
  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    .header-inner {
      width: 40%;
      display: flex;
      align-items: center;
      .content {
        flex: 1;
      }
    }
  }

  .img-box {
    padding: 15px 0;
    display: flex;
    .img-box-item {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
.panel-detail-footer {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  .panel-detail-footer-left {
    display: flex;
    align-items: center;
    .label {
      white-space: nowrap;
    }
  }
}
:deep(.el-step__icon) {
  border: 1px solid !important;
}
:deep(.el-icon-circle-close) {
  color: #EF6027 !important;
}
</style>
